import classNames from 'classnames';
import React from 'react';

type Props = {
  className?: string,
  disabled?: boolean,
  children?: React.ReactNode
};

class TableActions extends React.PureComponent<Props> {
  override render (): React.ReactNode {
    const { className, children, disabled } = this.props;

    return (
      <div className={classNames('esko_tableactions', {esko_tableactionsdisabled: disabled}, className)}>
        {children}
      </div>
    );
  }
}

export default TableActions;
